var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ready)?_c('apexchart',{ref:"chartRef",attrs:{"type":"line","options":_vm.themedChartOptions,"series":_vm.series,"height":_vm.customHeight}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }